export const _params = (params) => {
    if (params) {
        if (typeof params === 'string') {
            return _params(params.split(','));
        }

        if (typeof params === 'object') {
            if (Array.isArray(params) && params.length > 0) {
                return params
                    .map((v) => v.trim())
                    .filter((v) => !!v)
                    .reduce((bag, v) => ({ ...bag, [v]: true }), {});
            }

            return params;
        }
    }

    return true;
};
